import { render, staticRenderFns } from "./WaterReport.vue?vue&type=template&id=8e67f2c2&scoped=true&"
import script from "./WaterReport.vue?vue&type=script&lang=js&"
export * from "./WaterReport.vue?vue&type=script&lang=js&"
import style0 from "./WaterReport.vue?vue&type=style&index=0&id=8e67f2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e67f2c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCol,VDivider,VImg,VRow,VSimpleTable})
